import { Helmet } from 'react-helmet-async';
import React from 'react';
import requireAuth from '../../lib/requireAuth.jsx';
import withRouterParams from '../../lib/withRouterParams.jsx';

import EmployeeStakeholderProfilesContainer from '../../containers/employees/EmployeeStakeholderProfilesContainer.jsx';

const EmployeeStakeholderProfiles = ({ slug, employeeId, search }) => (
  <>
    <Helmet>
      <title>Employee Profile | ChangeSync</title>
    </Helmet>
    <EmployeeStakeholderProfilesContainer
      slug={slug}
      employeeId={employeeId}
      search={search}
    />
  </>
);

EmployeeStakeholderProfiles.getInitialProps = ({ query }) => ({
  slug: query.slug,
  employeeId: Number(query.employeeId),
  search: query.search || '',
});

export default requireAuth(withRouterParams(EmployeeStakeholderProfiles));
